import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryMetricsRangeArgs, SpaceliftMetrics } from "types/generated";

type GetDeploymentFrequencyRateData = {
  metricsRange: Pick<SpaceliftMetrics, "deploymentFrequencyRateValue">;
};

export const GET_DEPLOYMENT_FREQUENCY_RATE: TypedDocumentNode<
  GetDeploymentFrequencyRateData,
  QueryMetricsRangeArgs
> = gql`
  query GetDeploymentFrequencyRate($input: MetricsInput) {
    metricsRange(input: $input) {
      deploymentFrequencyRateValue {
        value
      }
    }
  }
`;
